import React from 'react';
import { useTranslation } from 'react-i18next';

const MensajeAvior = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="col-md-12 _pt-50">
                <div className="theme-search-results-sign-in bg-grad" style={{ borderRadius: "10px" }}>
                    <i className="theme-search-results-sign-in-icon fa fa-info"></i>
                    <h5 className="theme-search-results-sign-in-title">
                        {t('advertencia.mensaje1')}
                        <br/>
                        <a href={t('advertencia.mensaje2')} target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                            {t('advertencia.mensaje2')}
                        </a>
                    </h5>
                </div>
            </div>
        </>
    );
}

export default MensajeAvior;